import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router, NavigationEnd } from '@angular/router';
import firebase from 'firebase/compat/app';
import { environment } from 'src/environments/environment';
declare var gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Swift CSV';

  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
  ) {
    if (environment.production) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'UA-131145900-1', {
            page_path: event.urlAfterRedirects,
          });
        }
      });
    }

    this.afAuth.authState.subscribe((user: firebase.User) => {
      if (user) {
        if (this.router.url.startsWith('/auth')) {
          console.log('Logged In: Routing to Home');
          this.router.navigate(['/home/convert']);
        }
      } else {
        if (!this.router.url.startsWith('/auth')) {
          console.log('Not Logged In: Routing to Login');
          this.router.navigate(['auth/login']);
        }
      }
    });
  }
}
